import { Player } from "../models/Player";

export class PlayerService {
  private currentPlayerId: number;
  public allPlayers: Map<number, Player>;

  constructor() {
    this.allPlayers = new Map([
      [0, { name: "Rachel", isSelected: false }],
      [1, { name: "Squeegee", isSelected: false }],
      [2, { name: "Larry", isSelected: false }],
      [3, { name: "Kate", isSelected: false }],
      [4, { name: "Christina", isSelected: false }],
      [5, { name: "JP", isSelected: false }],
      [6, { name: "Max", isSelected: false }],
      [7, { name: "Diana", isSelected: false }],
      [8, { name: "Michael", isSelected: false }],
      [9, { name: "Puddles", isSelected: false }],
      [10, { name: "Jason", isSelected: false }],
      [11, { name: "Ryan", isSelected: false }],
      [12, { name: "Cassie", isSelected: false }],
      [13, { name: "Trisha", isSelected: false }],
    ]);

    this.currentPlayerId = 0;
  }

  public setCurrentPlayerId(playerId: number): void {
    this.currentPlayerId = playerId;
  }

  public getCurrentPlayer(): Player {
    const currentPlayerId = this.currentPlayerId;
    const player = this.allPlayers.get(currentPlayerId);
    return player as Player;
  }

  public setCurrentPlayer(playerId: number): void {
    this.setCurrentPlayerId(playerId);
    const currentPlayerObj = this.allPlayers.get(playerId) as Player;
    this.allPlayers.set(playerId, {
      name: currentPlayerObj.name,
      isSelected: true,
    });
  }

  public async randomizePlayer(): Promise<void> {
    let randomNumber: number = Math.floor(Math.random() * this.allPlayers.size);
    if (
      Array.from(this.allPlayers.values()).filter((a) => a.isSelected === false)
        .length === 0
    ) {
      alert(
        "whelp, everyone failed, if we manage to get here, you made a shit game Chris!",
      );
    } else if (this.allPlayers.get(randomNumber)?.isSelected) {
      this.randomizePlayer();
    } else {
      this.setCurrentPlayer(randomNumber);
    }
  }
}
